import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, isRef as _isRef, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3ec8a1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "head-line" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "tag-wrap arrow-right" }
const _hoisted_5 = { class: "info-item" }
const _hoisted_6 = { class: "info-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "更多", -1))

import { onActivated, Ref, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { showConfirmModal } from '@/utils/tools'
import { XssCommonPageListQuery } from '@/types/public'
import { ClientJijiaInsuranceListItem } from '@/types/insurance'
import { InsuranceJijiaOrderRefundDataStorage } from '@/storage/insurance'
import { PullRefresh, List, Popover, PopoverAction, Loading } from 'vant'
import { useInsuranceStore, useCommon } from '@/compositions/insurance/index'
import {
  getInsuranceStatusClassName,
  getInsuranceStatusDesc,
  judgeJijiaInsuranceCanRefund,
  judgeJijiaInsuranceCanDonwload,
  judgeInsuranceItemCanCorrect,
  judgeInsuranceItemCanShowMore,
} from '../common'
import { getClientJijiaInsuranceList, getClientJijiaInsuranceDetail } from '@/apis/insurance'
import AppHeader from '@/components/Header.vue'
import insuranceTagItem from '../components/insurance-tag-item.vue'
import JijiaInsuranceTips from '../components/jijia-insurance-tips.vue'
import useCommonList, { PageParams, PageListResut } from '@/compositions/useCommonList'

interface ListPopoverAction extends PopoverAction {
  policy_no: string
  detail: ClientJijiaInsuranceListItem
  type: string
}
type ListRenderItem = ClientJijiaInsuranceListItem & {
  showPopover: boolean
  tagClass: string
  actions?: PopoverAction[]
  showLoading?: boolean
  showPopoverWrap?: boolean
  insuranceType: string
  version: string
}

import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: 'insurance-jijia-insurance-list',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

// 机身险列表
const $router = useRouter()
const $route = useRoute()
const eq_sn = $route.query.eq_sn as string
const JIJIA_INSURANCE_LIST_REFRESH_KEY = 'jijiaInsuranceListNeedRefresh'
const { downloadPolicyOrder } = useCommon()
const { addInsuranceListKeepAlive, removeInsuranceListKeepAlive } = useInsuranceStore()

const refundCurrentItem: Ref<ClientJijiaInsuranceListItem | null> = ref(null)
function getPopoverAction(data: ClientJijiaInsuranceListItem): ListPopoverAction[] {
  const arr: ListPopoverAction[] = []
  if (judgeInsuranceItemCanCorrect(data)) {
    arr.push({ text: '批改被保人', policy_no: data.policy_no, detail: data, type: '3' })
  }
  if (judgeJijiaInsuranceCanRefund(data)) {
    arr.push({ text: '申请退保', policy_no: data.policy_no, detail: data, type: '1' })
  }
  if (judgeJijiaInsuranceCanDonwload(data)) {
    arr.push({ text: '保单下载', policy_no: data.policy_no, detail: data, type: '2' })
  }
  return arr
}
async function queryList(
  params: PageParams & XssCommonPageListQuery
): Promise<PageListResut<ListRenderItem>> {
  try {
    const data = await getClientJijiaInsuranceList({
      ...params,
      eq_sn,
    })
    const result = {
      ...data,
      data: data.data.map((item: ClientJijiaInsuranceListItem) => {
        return {
          ...item,
          showPopover: false,
          status_desc: getInsuranceStatusDesc(item.status, item.status_desc),
          tagClass: getInsuranceStatusClassName(item.status, item.status_desc),
          actions: getPopoverAction(item),
          showPopoverWrap: judgeInsuranceItemCanShowMore(item),
          insuranceType:
            item.insurance_type === 1 ? '首保' : item.insurance_type === 2 ? '首年二保' : '',
          version: `${item.product_info.pro_version}版`,
        }
      }),
    }
    return result
  } catch (error) {
    console.log('error', error)
    return Promise.reject(error)
  }
}
const {
  refreshing,
  loading,
  requestError,
  finished,
  onRefresh,
  dataList,
  queryHandle,
  finishedText,
  showLoadingRefresh,
} = useCommonList<ListRenderItem, XssCommonPageListQuery>(queryList, {
  emptyText: '暂无保单',
})

// 后续可优化的方式
async function updateList() {
  try {
    const currentListItem = dataList.value.filter(
      (item) => item.id === refundCurrentItem.value.id
    )[0]
    // currentListItem.showLoading = true
    const data = await getClientJijiaInsuranceDetail({ id: String(refundCurrentItem.value.id) })
    currentListItem.status_desc = getInsuranceStatusDesc(data.status, data.status_desc)
    currentListItem.tagClass = getInsuranceStatusClassName(data.status, data.status_desc)
    currentListItem.operation.operation_status = data.operation.operation_status
    currentListItem.showPopoverWrap = judgeInsuranceItemCanShowMore(data)
  } catch (error) {
    console.log('error', error)
  }
}
function toRefundHandle() {
  addInsuranceListKeepAlive()
  $router.push({
    name: 'insurance-service-jijia-order-refund',
  })
}
function actionSelect(action: ListPopoverAction) {
  // 处理退保， 暂不处理
  console.log('action', action)
  if (action.type === '1') {
    if (action.detail?.operation?.operation_status === 0) {
      showConfirmModal({
        title: '申请退保失败',
        message: action.detail.operation.message,
        confirmButtonText: '知道了',
        className: 'nongfu-dialog-confirm-class nongfu-dialog-confirm-error-class',
        showCancelButton: false,
      })
      return
    }
    InsuranceJijiaOrderRefundDataStorage.set(action.detail)
    toRefundHandle()
  } else if (action.type === '2') {
    downloadPolicyOrder(action.detail.policy_no)
  } else if (action.type === '3') {
    if (action.detail?.operation?.correct_message) {
      showConfirmModal({
        title: '保单批改失败',
        message: action.detail.operation.correct_message,
        confirmButtonText: '知道了',
        className: 'nongfu-dialog-confirm-class nongfu-dialog-confirm-error-class',
        showCancelButton: false,
      })
      return
    }
    addInsuranceListKeepAlive()
    $router.push({
      name: 'insurance-jijia-insurance-correct-select',
      query: {
        eq_sn: action.detail.eq_sn,
        id: String(action.detail.id),
      },
    })
  }
}
function toInsuranceDetail(item: ListRenderItem) {
  const query: Record<string, string | number> = {}
  query.eq_sn = item.eq_sn
  query.id = item.id
  if (item.policy_no) {
    query.policy_no = item.policy_no
  }
  addInsuranceListKeepAlive()
  $router.push({
    name: 'insurance-jijia-insurance-detail',
    query,
  })
}

onActivated(() => {
  const refreshEqSn = sessionStorage.getItem(JIJIA_INSURANCE_LIST_REFRESH_KEY)
  if (refreshEqSn && (!eq_sn || refreshEqSn === eq_sn)) {
    sessionStorage.removeItem(JIJIA_INSURANCE_LIST_REFRESH_KEY)
    void showLoadingRefresh()
  }
  removeInsuranceListKeepAlive()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "保单查询" }),
    _createVNode(_unref(PullRefresh), {
      modelValue: _unref(refreshing),
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(refreshing) ? (refreshing).value = $event : null)),
      onRefresh: _unref(onRefresh),
      class: "list-wrap"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(List), {
          loading: _unref(loading),
          "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => (_isRef(loading) ? (loading).value = $event : null)),
          error: _unref(requestError),
          "onUpdate:error": _cache[3] || (_cache[3] = ($event: any) => (_isRef(requestError) ? (requestError).value = $event : null)),
          finished: _unref(finished),
          offset: 200,
          "finished-text": _unref(finishedText),
          "error-text": "加载失败",
          onLoad: _unref(queryHandle),
          class: _normalizeClass(["list-container", _unref(dataList).length === 0 ? 'empty-wrap' : ''])
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataList), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                onClick: ($event: any) => (toInsuranceDetail(item)),
                class: "van-hairline--surround list-item"
              }, [
                (item.showLoading)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "loading-wrap",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createVNode(_unref(Loading), {
                        type: "spinner",
                        color: "#ffffff"
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(item.product_info.product_name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(insuranceTagItem, {
                      text: item.status_desc,
                      className: item.tagClass
                    }, null, 8, ["text", "className"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, "保单号：" + _toDisplayString(item.policy_no), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, " 保险时间：" + _toDisplayString(item.policy_start_at ? item.policy_start_at.split(' ')[0] : '') + " 至 " + _toDisplayString(item.policy_end_at ? item.policy_end_at.split(' ')[0] : ''), 1),
                  (item.showPopoverWrap)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _createVNode(_unref(Popover), {
                          show: item.showPopover,
                          "onUpdate:show": ($event: any) => ((item.showPopover) = $event),
                          placement: "bottom-end",
                          actions: item.actions,
                          "show-arrow": false,
                          class: "insurance-jijia-popover-item",
                          onSelect: actionSelect
                        }, {
                          reference: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 2
                        }, 1032, ["show", "onUpdate:show", "actions"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_1))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "error", "finished", "finished-text", "onLoad", "class"])
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"]),
    _createVNode(JijiaInsuranceTips)
  ], 64))
}
}

})